var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',{staticClass:"container-fluid",attrs:{"id":"home"}},[_c('OrkHomeGallery'),_c('div',{staticClass:"reassurance-wrapper"},[_c('OrkReassurance')],1),_c('BestSeller'),_c('LikedProduct'),_c('Universes')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }